/*
 * @description:
 * @author: wolfgun
 * @Date: 2020-10-16 16:13:22
 */
export const ROUTER_BANNER_ADD_OR_UPDATE = '/content/banner/add-or-update'
export const ROUTER_BANNER_VIEW = '/content/banner/detail'
export const ROUTER_BANNER_LIST = '/content/banner'

/**
 * 广告图显示状态-字典
 */
export const showStatusEnum = [
  { label: '全部', value: '' },
  { label: '显示', value: 1 },
  { label: '不显示', value: 0 }
]

/**
 * 广告图显示位置-字典
 */
export const positionEnum = [
  { label: '全部', value: '' },
  { label: '引导页面', value: 1 },
  { label: '聊天页面', value: 2 },
  { label: '我的页面', value: 3 }
]
